import React from 'react';
import { Link } from 'react-router-dom';

export default function MarketHomepage() {
  const product = {
    id: 1,
    title: "Example Product",
    price: "19.99",
    imageUrl: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQWzzHeZWfqaK1wuGs0vcKQvDVvN1EWJ_BdF8TmbSvBsCovnRtTo72t2kF3TObbgQJgjQk&usqp=CAU"
  };

  return (
    <div className="min-h-screen relative px-2 sm:px-4">
      <h1 className="text-3xl font-company text-pink-700 font-bold text-center mb-8">
        Marketplace
      </h1>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-4 px-4 justify-items-center">
        <Link
          to={`/product/${product.id}`}
          className="w-full max-w-[250px] p-4 border rounded shadow hover:shadow-lg transition"
        >
          <img
            src={product.imageUrl}
            alt={product.title}
            className="w-full h-40 object-cover mb-2"
          />
          <p className="text-md font-semibold truncate overflow-hidden whitespace-nowrap w-full">
            {product.title}
          </p>
          <h3 className="text-md font-semibold">${product.price}</h3>
        </Link>
      </div>
    </div>
  );
}